import { Component } from 'vue-property-decorator';
import Base from '@/components/Base';
import { ForgotPasswordCard } from '@streamlabs-core/sl-one-fe-components-vue2';

@Component({
  components: {
    ForgotPasswordCard,
  },
})
export default class SLForgot extends Base {
  onResetSuccess() {
    this.onRedirectRequested('login');
  }

  onRedirectRequested(to: string) {
    if (to === 'login')
      this.$router.push('/login');

    if (to === 'email')
      this.$router.push('/verify-email');

    if (to === 'tfa')
      this.$router.push('/verify-tfa');
  }
}
